import React from 'react';
import { getMessage } from '@tcc/i18n';
import { Button, ButtonFill, ComponentColor, Container, DialogContent, DialogFooter, Orientation, Typography, TypographyVariant } from '@tcc/fds';
import { RegionThumbnailNoteBox } from '../../RegionReportThumbnailNoteBox/RegionThumbnailNoteBox';
import { RegionReportModal } from '../RegionReportModal';
import type { BaseFieldRegionReportModalParams } from '../types/modals';

export interface NoHarvestDataViewProps extends BaseFieldRegionReportModalParams {
  activity: React.ComponentProps<typeof RegionThumbnailNoteBox>['activity'] | null | undefined;
  fieldName: string;
  geoJson: React.ComponentProps<typeof RegionThumbnailNoteBox>['geoJson'];
  isRegionValid: boolean | null;
  locale: string;
  onCancelConfirm: () => void;
  onDeleteConfirm: () => void;
  onRegionButtonClick: () => void;
  saveClick: () => void;
  showSaveButton: boolean;
}

export const NoHarvestDataView = ({
  activity,
  fieldName,
  geoJson,
  isRegionValid,
  locale,
  onCancelConfirm,
  onDeleteConfirm,
  onRegionButtonClick,
  saveClick,
  showSaveButton,
  onOpenChange,
  dialogTestId,
}: NoHarvestDataViewProps) => (
  <RegionReportModal
    dialogTestId={dialogTestId}
    modalViewKey='dmb-region-report-no-harvest-data'
    onOpenChange={onOpenChange}>
    <DialogContent testId='dmb-region-report-no-harvest-data'>
      <Container transparent orientation={Orientation.Vertical} width='100%'>
        {activity && (
          <RegionThumbnailNoteBox
            activity={activity}
            fieldName={fieldName}
            geoJson={geoJson}
            locale={locale}
            onRegionButtonClick={onRegionButtonClick}
          />
        )}

        <Typography variant={TypographyVariant.Body}>
          {!isRegionValid
            ? getMessage('regions.report.modal.noHarvestDataRegion')
            : getMessage('regions.report.modal.noHarvestData')}
        </Typography>
      </Container>
    </DialogContent>
    <DialogFooter>
      <Button
        testId='confirmation-modal-go-back-button'
        onClick={onCancelConfirm}
        fill={ButtonFill.Outline}
        color={ComponentColor.Primary}>
          {getMessage('confirmationModal.goBack')}
      </Button>

      {showSaveButton && (
        <Button
          testId='confirmation-modal-confirm-button'
          onClick={saveClick}
          fill={ButtonFill.Solid}
          color={ComponentColor.Primary}>
            {getMessage('regions.report.modal.saveReport')}
        </Button>
      )}

      {!showSaveButton && (
        <Button
          testId='confirmation-modal-confirm-button'
          onClick={onDeleteConfirm}
          fill={ButtonFill.Solid}
          color={ComponentColor.Error}>
            {getMessage('regions.report.modal.delete.report')}
        </Button>
      )}
    </DialogFooter>
  </RegionReportModal>
);
